import { Box, Divider } from '@mui/material';
import { concat, get } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, EMOB_INVEST_IMAGE_UPLOAD_FIELD_PROPS, FORM_FIELDS_TYPES, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { getFormStrucComponentTable } from 'src/utils/formStruc';
import { checkReadOnlyInUeberarbeitung, isTrue } from 'src/utils/helper';
import PruefAssistenz from '../../../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

const TechnischespezifikationLadeinfrastrukturAntragEmobInvest: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Technische Spezifikationen Ladeinfrastruktur' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0035907651_truktur_Pruefung_Pruefstatus.path
				}
				hinweisPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0148179138_nweis_Fuer_Den_Antragsteller.path
				}
				ueberarbeitetAmPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0217957821_ur_Pruefung_Ueberarbeitet_Am.path
				}
				erledigtPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0145248452_rastruktur_Pruefung_Erledigt.path
				}
				formStruc={formStrucPruefAssistenz()}
			/>

			<CreateForm
				formStruc={formStrucBedingung()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
			<Divider />
			{(
				isTrue(
					get(
						application,
						P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0184130766_rastruktur_Investiert_Werden
							.path,
					),
				)
			) ?
				<>
					<CreateForm
						formStruc={formStrucTabelle()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={updatedReadOnly}
					/>
					<Box sx={{ mt: '5rem' }}>
						<CreateForm
							formStruc={formStruc()}
							formValues={application}
							updateFormValuesFunc={setApplicationProperty}
							readOnly={updatedReadOnly}
						/>
					</Box>
				</>
			:	null}
		</>
	);
};
export default TechnischespezifikationLadeinfrastrukturAntragEmobInvest;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0145248452_rastruktur_Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStrucBedingung = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0184130766_rastruktur_Investiert_Werden],
		},
	];
	return struc;
};
const formStrucTabelle = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0231047921_en_Ladeinfrastruktur_Block_1,
					type: FORM_FIELDS_TYPES.editableTable,
					fieldProps: {
						Zelle_2: { width: '6rem' },
						Zelle_3: { width: '6rem' },
						Zelle_4: { width: '6rem' },
						Zelle_5: { width: '6rem' },
						Zelle_6: { width: '6rem' },
						Zelle_8: { width: '6rem' },
					},
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0123655138_zzweck_Der_Ladeinfrastruktur,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0176302946_astung_Der_Ladeinfrastruktur,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0172203671_epts_Und_Der_Stromversorgung,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0258851870_es_Inkl_Umgebungsbedingungen,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0131286926_zanschlussinkl_Baumassnahmen,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0013912722_rzeuge_Der_Ladeinfrastruktur,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0209183221_ruktur_Fuer_Elektrofahrzeuge,
				{
					...P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0193290210_nen_Ladeinfrastruktur_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...EMOB_INVEST_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucTechnischespezifikationLadeinfrastrukturAntragEmobInvest = (application: any) => {
	const isSollSrucTrue = isTrue(
		get(
			application,
			P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0184130766_rastruktur_Investiert_Werden.path,
		),
	);

	if (isSollSrucTrue) {
		const componentTableWithIndex = getFormStrucComponentTable(application, formStrucTabelle());

		if (
			checkIfPruefAssitenzNeedsToValidate(
				application,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0035907651_truktur_Pruefung_Pruefstatus.path,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0145248452_rastruktur_Pruefung_Erledigt.path,
			)
		)
			return concat(formStrucPruefAssistenz(), formStruc(), componentTableWithIndex);
		return concat(formStruc(), componentTableWithIndex);
	}
	return [];
};
